
//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(11460018), 3000);
var track = require("./lib/tracking");



